export default __webpack_public_path__ + "media/components/AdEdit/images/facebook-comment-1a998d21d286c2a7bc825064269e9d19.png";